export const initialValues = {
  board_id: '',
  level: 1,
  proc_hierarchy_id: '',
  name: '',
  output: '',
  objective: '',
  parent_id: '',
  parent_id_label: '',
  main_indicator: '',
  dataWorkload: [],
  type_process_parent: '',
};
